<rx-intuitive-teeth-treatment-viewlist
	*ngIf="showTreatmentViewList$ | async"
	[treatmentListItems]="(previewTreatmentListItems$ | async) ?? []"
	[readOnly]="(toothEditorReadOnly$ | async) ?? false"
	(clicked)="onOpenTreatmentEditorFromList($event)"
/>
<rx-intuitive-tooth-editor
	*ngIf="isToothEditorShown$ | async"
	[teeth]="(editorTeeth$ | async) ?? []"
	[canEdit]="(canEditToothEditor$ | async) ?? true"
	[canDelete]="(canDeleteToothEditor$ | async) ?? true"
	(delete)="clearSelection()"
	(crownFormChanged)="onToothCrownFormChanged($event)"
	(additionalInfoApplied)="onToothAdditionalInfoApplied($event)"
	(clearDisabledFields)="onToothClearDisabledFields($event)"
/>
<div class="rx-intuitive-teeth-diagram__no-editor" *ngIf="showSidePanelPlaceholder$ | async">
	{{ 'TeethDiagram.SelectTeethToStart' | translate }}
</div>